import accessService from '@/api/accesscontrol.js'
import errorhandler from '@/utils/errorhandler.js'
import filedownloader from '@/utils/filedownloader.js'
import i18n from '@/i18n'

export default {
  namespaced: true,
  state: {
    isDownloadingFile: false,
    lastUsedFilters: null
  },
  getters: {
    lastUsedFilters: state => state.lastUsedFilters
  },
  mutations: {
    setIsDownloadingFile(state, value) {
      state.isDownloadingFile = value
    },
    setLastUsedFilters(state, filters) {
      state.lastUsedFilters = filters
    }
  },
  actions: {
    async getAccessesFilters() {
      try {
        const response = await accessService.getAccessesFilters()
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async searchPersons(_, { query }) {
      try {
        if (!query || query.trim() === '') {
          return []
        }
        
        const params = {
          term: query,
          amount: 5
        }
        const response = await accessService.searchPersons(params)
        return response.data.map(person => ({
          id: person.id,
          name: person.name,
          email: person.email || person.name
        }))
      } catch (error) {
        errorhandler.handleError(error)
        return []
      }
    },
    async searchAccessLogs(_, filters) {
      try {
        const response = await accessService.searchAccessLogs(filters)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
        return []
      }
    },
    async exportAccessLogs({ dispatch, commit }, filters) {
      if (filters) {
        commit('setLastUsedFilters', filters)
      }
      
      const filtersToUse = filters || this.state.AccessControl.lastUsedFilters
      
      if (!filtersToUse) {
        dispatch('Global/showMessage', i18n.t('applyFiltersBeforeExporting'), { root: true })
        return
      }
      
      await filedownloader.downloadFile(
        accessService.exportAccessLogs.bind(accessService),
        'access-logs.xlsx',
        filtersToUse,
        dispatch
      )
    },
    setIsDownloadingFile({ commit }, value) {
      commit('setIsDownloadingFile', value)
    }
  }
}
